import { Node } from "@tiptap/core";

export default Node.create({
  name: "mathliveFormula",
  group: "inline",
  inline: true,
  atom: true,

  addAttributes() {
    return {
      latex: {
        default: "",
      },
    };
  },

  parseHTML() {
    return [{ tag: "math-field" }];
  },

  renderHTML({ node }) {
    return [
      "math-field",
      { "math-virtual-keyboard-policy": "manual" },
      node.attrs.latex,
    ];
  },

  addNodeView() {
    return ({ node }) => {
      const mathfield = document.createElement("math-field");
      mathfield.className = "inline-formula";
      mathfield.value = node.attrs.latex;
      mathfield.readOnly = true;

      return {
        dom: mathfield,
      };
    };
  },
});
